import { FC } from 'react';
import dynamic from 'next/dynamic';

const BusinessHubStatsMobile = dynamic(() => import('./business-hub-stats-mobile'));

export interface Stats {
    title: string;
    stats: {
        hidePercent?: boolean;
        plus?: boolean;
        percent: string;
        description: string;
    }[];
}

export interface BusinessHubStatsProps {
    stats: Stats[];
}

const BusinessHubStats: FC<BusinessHubStatsProps> = (props) => {
    return <BusinessHubStatsMobile {...props} />;
};

export default BusinessHubStats;
